// extracted by mini-css-extract-plugin
module.exports = {"balance-detail":"balance-detail--aCx-h","label":"label--BQV-9","cloud":"cloud--1TaJX","drop":"drop--12nk9"};